import React, { useState, useEffect } from "react";
import FileManager from "./UserImgcredit/UserImgcredit";
import { Button } from "react-bootstrap";
import TermsModal from "./TermsModal";
import ShippingPolicyModal from "./ShippingPolicyModal";
import RefundPolicyModal from "./RefundPolicyModal";
import ContactModal from "./ContactModal";
import PrivacyPolicyModal from "./PrivacyPolicyModal";

import googleSignIn from "images/signinGoogle.svg";

import {
  Camera,
  Users,
  Palette,
  MessageSquare,
  Zap,
  Play,
  ArrowRight,
  CheckCircle2,
  Sparkles,
  ShieldCheck,
  Heart,
  Car,
  Globe,
  Shirt,
  Gem,
  Layers,
  MousePointer2,
  Tag,
  Settings,
  Terminal,
  Aperture,
  Fingerprint,
  UserCheck,
  Cpu,
  Menu,
  Info,
  X
} from "./Icons";

// import Friend1 from "../../assets/images/collageImages/Friend1.jpg";
// import Friend2 from "../../assets/images/collageImages/Friend2.jpg";
// import Friend3 from "../../assets/images/collageImages/Friend3.jpg";
// import Friends_Final from "../../assets/images/collageImages/Friends-Final.png";

// import bike from "../../assets/images/collageImages/bike.jpg";
// import bike_boots from "../../assets/images/collageImages/bike_boots.png";
// import bike_dress from "../../assets/images/collageImages/bike_dress.png";
// import bike_gloves from "../../assets/images/collageImages/bike_gloves.jpg";
// import bike_subject from "../../assets/images/collageImages/bike_subject.jpeg";
// import bike_final from "../../assets/images/collageImages/bike_final.png";

// import us_bike_subject from "../../assets/images/collageImages/us_bike_subject.jpg";
// import us_bike_final from "../../assets/images/collageImages/us_bike_final.png";

// import Girl_Final from "../../assets/images/collageImages/Girl_Final.png";
// import Girl_Jewelry from "../../assets/images/collageImages/Girl_Jewelry.png";
// import Girl_Reference from "../../assets/images/collageImages/Girl_Reference.png";
// import Girl_Subject from "../../assets/images/collageImages/Girl_Subject.png";
// import bangle_right from "../../assets/images/collageImages/bangle_right.png";
// import bangle_left from "../../assets/images/collageImages/bangle_left.jpg";

// import US_Family_1_Final from "../../assets/images/collageImages/us_family_1_final.png";
// import US_DAD from "../../assets/images/collageImages/us_dad1.jpg";
// import US_MOM from "../../assets/images/collageImages/us_woman1.jpg";
// import US_SON from "../../assets/images/collageImages/us_boy1.jpg";
// import US_DAUGHTER from "../../assets/images/collageImages/us_girl1.jpg";
// import US_SON2 from "../../assets/images/collageImages/us_boy2.jpg";

// import US_Family_2_Final from "../../assets/images/collageImages/US_Family_2_Final.png";
// import BDAD1 from "../../assets/images/collageImages/bdad1.jpg";
// import BMOM1 from "../../assets/images/collageImages/bmom1.jpg";
// import BSON1 from "../../assets/images/collageImages/bboy-1.jpg";
// import BGIRL_1 from "../../assets/images/collageImages/bgirl-2.jpg";
// import MYDOG from "../../assets/images/collageImages/mydog.jpg";

// import Family_1_Final from "../../assets/images/collageImages/Family_1_Final.jpg";
// // import Family_Temp from "../../assets/images/collageImages/Family.png";
// import DAD from "../../assets/images/collageImages/dad.jpg";
// import MOM from "../../assets/images/collageImages/mom.jpg";
// import SON from "../../assets/images/collageImages/son.png";
// import DAUGHTER from "../../assets/images/collageImages/daughter.jpg";

// // import Family_2_Final from "../../assets/images/collageImages/Family_2_Final.png";
// import Family_2_Final from "../../assets/images/collageImages/fam-final.png";
// import DAD2 from "../../assets/images/collageImages/dad2.jpg";
// import MOM2 from "../../assets/images/collageImages/mom2.jpg";
// import SON2 from "../../assets/images/collageImages/son2.jpg";
// import DAUGHTER2 from "../../assets/images/collageImages/daughter2.jpg";

// import SAREE from "../../assets/images/collageImages/saree.png";

// import GROUP_REF from "../../assets/images/collageImages/group_ref.png";
// import GROUP_REF2 from "../../assets/images/collageImages/group-ref2.jpg";

// import CORP_GROUP_FINAL from "../../assets/images/collageImages/corp_group_final.png";
// import STAFF1 from "../../assets/images/collageImages/staff1.jpg";
// import STAFF2 from "../../assets/images/collageImages/staff2.jpg";
// import STAFF3 from "../../assets/images/collageImages/staff3.jpg";
// import STAFF4 from "../../assets/images/collageImages/staff4.jpg";
// import MANAGER from "../../assets/images/collageImages/manager.jpg";

// import CORP_US_FINAL from "../../assets/images/collageImages/corp_us_final.png";
// import US_STAFF1 from "../../assets/images/collageImages/us_staff1.jpg";
// import US_STAFF2 from "../../assets/images/collageImages/us_staff2.jpg";
// import US_STAFF3 from "../../assets/images/collageImages/us_staff3.jpg";
// import US_STAFF4 from "../../assets/images/collageImages/us_staff4.jpg";
// import US_MANAGER from "../../assets/images/collageImages/us_manager.jpg";

// import BS_1 from "../../assets/images/collageImages/bs-1.jpg";
// import BS_2 from "../../assets/images/collageImages/bs-2.jpg";
// import BS_3 from "../../assets/images/collageImages/bs-3.jpg";

// import CHRISTMAS_MAN1 from "../../assets/images/collageImages/Christmas-man1.jpg";
// import CHRISTMAS_MAN2 from "../../assets/images/collageImages/Christmas-man2.jpg";
// import CHRISTMAS_GIRL1 from "../../assets/images/collageImages/Christmas-girl1.jpg";
// import CHRISTMAS_GIRL2 from "../../assets/images/collageImages/Christmas-girl2.jpg";
// import CHRISTMAS_GIRL3 from "../../assets/images/collageImages/Christmas-girl3.jpg";
// import CHRISTMAS_REF from "../../assets/images/collageImages/Christmas-ref.jpg";
// import CHRISTMAS_FAMILY_FINAL from "../../assets/images/collageImages/Christmas_Family_Final.png";

const getCookie = (cname) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

const LandingPage = (mobile, user_id, imgCredits) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [buyFlg, setBuyFlg] = useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isShippingModalOpen, setIsShippingModalOpen] = useState(false);
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);

  let countryCode = getCookie("countryCode");
  // let countryCode = "US";

  useEffect(() => {
    if (
      selectedImage ||
      isShippingModalOpen ||
      isRefundModalOpen ||
      isContactModalOpen ||
      isPrivacyModalOpen
    ) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [selectedImage]);

  const menuItems = [
    { label: "About", href: "#about" },
    { label: "Pricing", href: "#" },
    { label: "Login", href: "/users/sign_in" }
  ];

  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  const handleLoad = async (event) => {
    const { naturalWidth, naturalHeight } = event.target;
    setDimensions({ width: naturalWidth, height: naturalHeight });
  };

  const collageItems = [
    {
      id: "portrait",
      url: "/images/webp/Girl_Final.webp",
      title: "Fantastic Female Portrait",
      prompt:
        '"Keep original hairstyle of Subject. Remove eyewear of Subject. This is a professional full-legth studio portrait happening in a high-end studio using high-end camera with dramatic and cinematic lighting. Use appropriate high-end studio backdrop."',
      remarks:
        "Please note: 'AI' can never recreate the same picture it created before!!",
      span: "col-span-3 row-span-3",
      references: [
        { url: "/images/webp/Girl_Subject.webp", prompt: "Subject Identity" },
        { url: "/images/webp/Girl_Reference.webp", prompt: "Use this dress" },
        { url: "/images/webp/Girl_Jewelry.webp", prompt: "Use this Jewelry" },
        {
          url: "/images/webp/bangle_left.webp",
          prompt: "Use this bangle on the right hand"
        },
        {
          url: "/images/webp/bangle_right.webp",
          prompt: "Use these bangles on the left hand"
        }
      ],
      resolution: "1K"
    },

    {
      id: "family",
      url:
        countryCode !== "IN" && countryCode !== ""
          ? "/images/webp/US_Family_2_Final.webp"
          : "/images/webp/fam-final.webp",
      title:
        countryCode !== "IN" && countryCode !== ""
          ? "Studio Family Group Portrait with a Pet"
          : "Studio Family Group Portrait with a Pet",
      prompt:
        countryCode !== "IN" && countryCode !== ""
          ? '"This is a family portrait shoot, shot with high-end camera with dramatic and cinematic lighting. Add mydog to the bottom right."'
          : '"This is a family portrait shoot, shot with high-end camera with dramatic and cinematic lighting. Add mydog to the bottom right."',
      remarks:
        countryCode !== "IN" && countryCode !== ""
          ? "Please note: Final group picture's 'EXACT POSTURE' composition is always a 'Similar posture' based on the reference image as it is a very complex generation process as deemed by Google. If number of subjects, gender, age and positional mappings are correct, you might get the exact posture. Adding a pet which is not in the reference image, adds to the complexity and impacts posture. You may not always get the composition/mapping correct or the dress not applied correctly due to age and or gender mismatch amongst other factors, even though you have mentioned every little things correctly. You can also use specific dress for specific subjects using snippets. Sometimes, the ai choose not to apply chosen dress. So, be aware of slight imperfections. Inspite of all this, almost all of the times you will be delighted with the output as it did for us even though the posture may not be exact match as you see here! Good Luck. PS: For mapping a figure in the reference image, 'a figure on the left' means, figure is on the left from your view as you see, not from the reference image view!"
          : "Please note: Final group picture's 'EXACT POSTURE' composition is always a 'Similar posture' based on the reference image as it is a very complex generation process as deemed by Google. If number of subjects, gender, age and positional mappings are correct, you might get the exact posture. Adding a pet which is not in the reference image, adds to the complexity and impacts posture. You may not always get the composition/mapping correct or the dress not applied correctly due to age and or gender mismatch amongst other factors, even though you have mentioned every little things correctly. You can also use specific dress for specific subjects using snippets. Sometimes, the ai choose not to apply chosen dress. So, be aware of slight imperfections. Inspite of all this, almost all of the times you will be delighted with the output as it did for us even though the posture may not be exact match as you see here! Good Luck. PS: For mapping a figure in the reference image, 'a figure on the left' means, figure is on the left from your view as you see, not from the reference image view!",
      span: "col-span-3 row-span-2",

      references:
        countryCode !== "IN" && countryCode !== ""
          ? [
              {
                url: "/images/webp/bdad1.webp",
                prompt: "Group Identifier: SUB1, Posture: 'Clone Reference'"
              },
              {
                url: "/images/webp/bmom1.webp",
                prompt: "Group Identifier: SUB2 Posture: 'Clone Reference'"
              },
              {
                url: "/images/webp/bboy-1.webp",
                prompt: "Group Identifier: SUB3 Posture: 'Clone Reference'"
              },
              {
                url: "/images/webp/bgirl-2.webp",
                prompt: "Group Identifier: SUB4 Posture: 'Clone Reference'"
              },
              {
                url: "/images/webp/mydog.webp",
                prompt: "Group Identifier: MYDOG Posture: 'Clone Reference'"
              },
              {
                url: "/images/webp/group-ref2.webp",
                prompt: `GLOBAL COMPOSITION BLUEPRINT: Map 'sub1' to the figure standing on top row. Map 'sub2' to the figure sitting in the middle row, left. Map 'sub3' to figure standing in the middle row, right. Map 'sub4' to the bottom figure. Blueprint Directive: Replicate this exact Pose. Use this dress.`
              }
            ]
          : [
              {
                url: "/images/webp/dad2.webp",
                prompt: "Group Identifier: SUB1, Posture: 'Clone Reference'"
              },
              {
                url: "/images/webp/mom2.webp",
                prompt: "Group Identifier: SUB2, Posture: 'Clone Reference'"
              },
              {
                url: "/images/webp/son2.webp",
                prompt: "Group Identifier: SUB3, Posture: 'Clone Reference'"
              },
              {
                url: "/images/webp/daughter2.webp",
                prompt: "Group Identifier: SUB4, Posture: 'Clone Reference'"
              },
              {
                url: "/images/webp/mydog.webp",
                prompt: "Group Identifier: MYDOG Posture: 'Clone Reference'"
              },
              {
                url: "/images/webp/group_ref.webp",
                prompt: `GLOBAL COMPOSITION BLUEPRINT: Replicate this exact pose. Map 'sub1' to the figure standing on the left. Map 'sub2' to the figure standing on the right. Map 'sub3' to the figure siting in the middle. Map 'sub4' to the bottom left figure. Use this dress.`
              }
            ],
      resolution: "2K"
    },
    {
      id: "bike",
      url:
        countryCode !== "IN" && countryCode !== ""
          ? "/images/webp/us_bike_final.webp"
          : "/images/webp/bike_final.webp",
      title: "Subject on Bike",
      prompt:
        countryCode !== "IN" && countryCode !== ""
          ? '"This is a high-quality outdoor shoot of the full view of the subject sitting on the bike, shot by a professional photographer using high-end wide-angle camera."'
          : '"Please note: No Global Prompt Given. All directives are given in StyleBuilder Blueprints!"',
      remarks:
        "Please note: 'AI' can never recreate the same picture it created before!!",
      span: "col-span-3 row-span-2",
      references:
        countryCode !== "IN" && countryCode !== ""
          ? [
              {
                url: "/images/webp/us_bike_subject.webp",
                prompt: "Subject Identity"
              },
              {
                url: "/images/webp/bike.webp",
                prompt:
                  "Use this full bike. Subject sitting on this bike in a riding position. Use this background as well. Full view of the subject and bike in the output image.."
              },
              { url: "/images/webp/bike_dress.webp", prompt: "Use this dress" },
              {
                url: "/images/webp/bike_gloves.webp",
                prompt: "Use this glove"
              },
              { url: "/images/webp/bike_boots.webp", prompt: "Use these boots" }
            ]
          : [
              {
                url: "/images/webp/bike_subject.webp",
                prompt: "Subject Identity"
              },
              {
                url: "/images/webp/bike.webp",
                prompt:
                  "Use this full bike. Subject sitting on this bike in a riding position. Use this background as well."
              },
              {
                url: "/images/webp/bike_dress.webp",
                prompt: "Use this riding gear"
              },
              {
                url: "/images/webp/bike_gloves.webp",
                prompt: "Use this gloves"
              },
              { url: "/images/webp/bike_boots.webp", prompt: "Use these boots" }
            ],
      resolution: "2K"
    },

    {
      id: "tajmahal",
      url:
        countryCode !== "IN" && countryCode !== ""
          ? "/images/webp/US_Family_1_Final.webp"
          : "/images/webp/Family_1_Final.webp",
      title: "Family Portrait at Taj Mahal",
      prompt:
        countryCode !== "IN" && countryCode !== ""
          ? "This is a full-size family portrait of 5 shot at the location of Taj Mahal by a professional photographer using high-end camera and Taj Mahal as the backdrop. Use professional business suit for dad and mom.  Use casual clothing for son, daughter and son2. Keep original expressions of dad, mom, son, daughter and son2."
          : "This is a high-end full-length family portrait of 4 consisting of DAD, MOM, DAUGHTER & SON, shot at the location of Taj Mahal by a professional Photographer using a high-end camera with Taj Mahal as the backdrop.",
      remarks:
        "Please note: 'AI' can never recreate the same picture it created before!!",
      span: "col-span-3 row-span-3",
      references:
        countryCode !== "IN" && countryCode !== ""
          ? [
              {
                url: "/images/webp/us_dad1.webp",
                prompt: "Group Identifier: DAD"
              },
              {
                url: "/images/webp/us_woman1.webp",
                prompt: "Group Identifier: MOM"
              },
              {
                url: "/images/webp/us_boy1.webp",
                prompt: "Group Identifier: SON"
              },
              {
                url: "/images/webp/us_girl1.webp",
                prompt: "Group Identifier: DAUGHTER"
              },
              {
                url: "/images/webp/us_boy2.webp",
                prompt: "Group Identifier: SON2"
              }
            ]
          : [
              { url: "/images/webp/dad.webp", prompt: "Group Identifier: DAD" },
              { url: "/images/webp/mom.webp", prompt: "Group Identifier: MOM" },
              { url: "/images/webp/son.webp", prompt: "Group Identifier: SON" },
              {
                url: "/images/webp/daughter.webp",
                prompt: "Group Identifier: DAUGHTER"
              }
            ],
      resolution: countryCode !== "IN" && countryCode !== "" ? "2K" : "4K"
    },

    {
      id: "corpgroup",
      url:
        countryCode !== "IN" && countryCode !== ""
          ? "/images/webp/corp_us_final.webp"
          : "/images/webp/corp_group_final.webp",
      title: "Corporate Group Picture",
      prompt:
        '"This is a corporate group picture shot with photorealistic, cinematic lighting, in a modern, brightly lit boardroom, where manager is in the middle and staff1 & staff2 are on the left side of manager and staff3 & staff4 are on the right side of manager.  Keep original expressions of all staff, standing together in a relaxed group pose near a glass-topped boardroom table. Soft natural lighting from large windows with a city view. "',
      remarks:
        "Please note: 'AI' can never recreate the same picture it created before!!",
      span: "col-span-3 row-span-1",
      references:
        countryCode !== "IN" && countryCode !== ""
          ? [
              {
                url: "/images/webp/us_staff1.webp",
                prompt: "Group Identifier: staff1"
              },
              {
                url: "/images/webp/us_staff2.webp",
                prompt: "Group Identifier: staff2"
              },
              {
                url: "/images/webp/us_manager.webp",
                prompt: "Group Identifier: manager"
              },
              {
                url: "/images/webp/us_staff3.webp",
                prompt: "Group Identifier: staff3"
              },
              {
                url: "/images/webp/us_staff4.webp",
                prompt: "Group Identifier: staff4"
              },
              {
                url: "/images/webp/bs-1.webp",
                prompt:
                  "StyleBuilder Directive: Use this dress for staff2 and staff4"
              },
              {
                url: "/images/webp/bs-2.webp",
                prompt: "StyleBuilder Directive: Use this dress for manager"
              },
              {
                url: "/images/webp/bs-3.webp",
                prompt:
                  "StyleBuilder Directive: Use this dress for staff1 and staff3"
              }
            ]
          : [
              {
                url: "/images/webp/staff1.webp",
                prompt: "Group Identifier: staff1"
              },
              {
                url: "/images/webp/staff2.webp",
                prompt: "Group Identifier: staff2"
              },
              {
                url: "/images/webp/manager.webp",
                prompt: "Group Identifier: manager"
              },
              {
                url: "/images/webp/staff3.webp",
                prompt: "Group Identifier: staff3"
              },
              {
                url: "/images/webp/staff4.webp",
                prompt: "Group Identifier: staff4"
              },
              {
                url: "/images/webp/bs-1.webp",
                prompt:
                  "StyleBuilder Directive: Use this dress for staff1 and staff2"
              },
              {
                url: "/images/webp/bs-2.webp",
                prompt: "StyleBuilder Directive: Use this dress for manager"
              },
              {
                url: "/images/webp/bs-3.webp",
                prompt:
                  "StyleBuilder Directive: Use this dress for staff3 and staff4"
              }
            ],
      resolution: "4K"
    },
    {
      id: "friends",
      url:
        countryCode !== "IN" && countryCode !== ""
          ? "/images/webp/Christmas_Family_Final.webp"
          : "/images/webp/Friends-Final.webp",
      title:
        countryCode !== "IN" && countryCode !== ""
          ? "Christmas Family Portrait"
          : "Friends Professional Portrait",
      prompt:
        countryCode !== "IN" && countryCode !== ""
          ? "This is a family Christmas portrait shoot performed by a professional photographer who shot with a high-end camera with dramatic and cinematic lighting."
          : '"Use Tuxedo as dress code for Friend1, Friend2 & Friend3. This is a Friends shot happening in High-end Studio, Shot with High-end Camera with Dramatic & Cinematic Studio Lighting. Use appropriate High-end studio backdrop."',
      remarks:
        countryCode !== "IN" && countryCode !== ""
          ? "Please Note: While it is easy to get a group posture similar to a reference group image, if the reference image has same number of subjects and matching genders as yours, it is often you will find yourselves in situations where you might have reference images you like but carries more or less subjects than yours. This example is a perfect demonstration for that to show how easily you can map to any reference image with ease. With the 'Global Composition Blueprint's mapping tool you can easily map your IDENTIFIERS to any figures in the reference image even if your reference image carries more figures/models/subjects than yours. Simply unmap or remove those figures from the reference image and only match subjects you wanted. You can also add your subjects by simply stating 'Add sub-x' to the right of 'sub-1'. Now you can easily create a family group portrait reflecting any environment and or mood for your occassion even with an imperfect reference image.  You can also change dress/attire for each individual subject using Blueprint snippets. Remember, you are the 'Creative Art director'. Create your Masterpiece! Good Luck!"
          : "Please note: 'AI' can never recreate the same picture it created before!!",
      span: "col-span-3 row-span-1",
      references:
        countryCode !== "IN" && countryCode !== ""
          ? [
              {
                url: "/images/webp/Christmas-man1.webp",
                prompt: "Group Identifier: sub-1, Posture: CLONE REFERENCE"
              },
              {
                url: "/images/webp/Christmas-man2.webp",
                prompt: "Group Identifier: sub-2, Posture: CLONE REFERENCE"
              },
              {
                url: "/images/webp/Christmas-girl1.webp",
                prompt: "Group Identifier: sub-3, Posture: CLONE REFERENCE"
              },
              {
                url: "/images/webp/Christmas-girl2.webp",
                prompt: "Group Identifier: sub-4, Posture: CLONE REFERENCE"
              },
              {
                url: "/images/webp/Christmas-girl3.webp",
                prompt: "Group Identifier: sub-5, Posture: CLONE REFERENCE"
              },
              {
                url: "/images/webp/Christmas-ref.webp",
                prompt:
                  "GLOBAL COMPOSITION BLUEPRINT: Map sub-1 to figure sitting on the far left, map sub-2 to the figure sitting in the center, map sub-3 to the figure sitting first from far left sitting figure, map sub-4 to figure standing on the right from far left standing figure and map sub-5 to the figure standing on the far right. Blueprint Directive: Replicate this exact pose. Use this dress code. Replicate this environment including tree, food, etc. "
              }
            ]
          : [
              {
                url: "/images/webp/Friend1.webp",
                prompt: "Group Identifier: Friend1"
              },
              {
                url: "/images/webp/Friend2.webp",
                prompt: "Group Identifier: Friend2"
              },
              {
                url: "/images/webp/Friend3.webp",
                prompt: "Group Identifier: Friend3"
              }
            ],
      resolution: countryCode !== "IN" && countryCode !== "" ? "2K" : "4K"
    }
  ];

  return (
    <div
      className="min-h-screen bg-[#0f172a] text-slate-50 overflow-x-hidden"
      style={{ marginTop: mobile ? "-10px" : "-20px" }}
    >
      {/* Fixed button(s)*/}
      {user_id != -1 ? (
        <React.Fragment>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              marginTop: "-25px",
              marginBottom: "10px"
            }}
          >
            {/* <FileManager></FileManager> */}
            {buyFlg && <FileManager flg={buyFlg} setBuyFlg={setBuyFlg} />}
          </div>
        </React.Fragment>
      ) : (
        ""
      )}

      {/* Navigation */}

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 px-6 overflow-hidden">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full -z-10 opacity-20">
          <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-indigo-600 blur-[120px] rounded-full" />
          <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-emerald-600 blur-[120px] rounded-full" />
        </div>

        <div
          className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center"
          style={{ marginTop: mobile ? "-20px" : "" }}
        >
          <div
            className="animate-slide-up"
            style={{ marginTop: mobile ? "" : "-50%" }}
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-sm font-medium mb-6">
              {/* <Zap className="w-4 h-4" /> */}
              <Zap style={{ width: "20px", height: "15px" }} />
              <span style={{ fontSize: "20px" }}>
                Next-Gen AI Portrait Studio
              </span>
            </div>
            {/* <h1 className="text-6xl lg:text-8xl font-bold leading-[0.9] tracking-tight mb-8"> */}
            <h1
              className="text-6xl lg:text-8xl text-white font-bold leading-[0.9] tracking-tight mb-8"
              style={{ marginTop: "10px", lineHeight: "1" }}
            >
              Your Vision, <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-emerald-400">
                Perfectly Composed.
              </span>
            </h1>
            <p className="text-xl text-slate-400 mb-10 max-w-xl leading-relaxed">
              Transform casual photos into studio-quality masterpieces. From
              professional headshots to family portraits with pets, aiComposz
              brings your imagination to life.
            </p>
            {user_id != -1 ? (
              <div className="flex flex-wrap gap-4">
                <button
                  // onClick={onStart}
                  onClick={() => {
                    if (imgCredits > -1) {
                      window.location.href = `/enhance?imgCredits=${imgCredits}`;
                    } else {
                      alert(
                        "Please purchase 'Image Credits' before continuing..."
                      );
                      setBuyFlg(false);
                    }
                  }}
                  className={
                    imgCredits > -1
                      ? "bg-indigo-600 hover:bg-indigo-500 text-white px-6 py-4 rounded-2xl font-bold text-lg flex items-center gap-2 transition-all shadow-xl shadow-indigo-500/20 group"
                      : "text-white px-6 py-4 rounded-2xl font-bold text-lg flex items-center gap-2 transition-all shadow-xl shadow-indigo-500/20 group"
                  }
                  // disabled={imgCredits > 0 ? false : true}
                  style={{ backgroundColor: imgCredits > -1 ? "" : "grey" }}
                  title={imgCredits > 0 ? "" : "Buy Image Credits first!"}
                >
                  Start App
                  {/* <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" /> */}
                  <ArrowRight className="w-5 md:h-5 group-hover:translate-x-1 transition-transform" />
                </button>

                <button
                  className="bg-slate-800 hover:bg-slate-700 text-white px-4 py-1.5 rounded-2xl font-bold text-lg flex items-center gap-2 transition-all border border-slate-700"
                  onClick={() => setBuyFlg(true)}
                  style={{ backgroundColor: "rgb(230 51 147)" }}
                >
                  <span>
                    Buy Image Credits
                    <br></br>
                    {/* <br></br> */}
                    <span
                      style={{
                        color: imgCredits > 0 ? "#f9ff00" : "black"
                        // fontSize: "12px",
                      }}
                    >
                      ({imgCredits} available)
                    </span>
                  </span>
                </button>
              </div>
            ) : (
              <React.Fragment>
                <div className="flex flex-wrap gap-1">
                  {/* <button
                  // onClick={onStart}
                  onClick={() => {
                    window.location.href = "/users/sign_in";
                  }}
                  className="bg-indigo-600 hover:bg-indigo-500 text-white px-8 py-4 rounded-2xl font-bold text-lg flex items-center gap-2 transition-all shadow-xl shadow-indigo-500/20 group"
                >
                  Register / Login
                  <ArrowRight className="w-5 md:h-5 group-hover:translate-x-1 transition-transform" />
                </button> */}

                  <button
                    // onClick={onStart}
                    onClick={() => {
                      window.location.href = "/users/sign_in";
                    }}
                    className="bg-indigo-600 hover:bg-indigo-500 text-white px-3 py-2 rounded-2xl font-bold text-sm flex items-center gap-2 transition-all shadow-xl shadow-indigo-500/20 group"
                  >
                    Register / Login
                  </button>

                  <button
                    // onClick={onStart}
                    onClick={() => {
                      window.location.href = "/users/auth/google_oauth2";
                    }}
                  >
                    <img src={googleSignIn} alt="" height="40"></img>
                  </button>
                </div>
              </React.Fragment>
            )}

            {/* <div className="mt-10 flex items-center gap-6 text-slate-500">
              <div className="flex items-center gap-2">
                <CheckCircle2 className="w-5 md:h-5 text-emerald-500" />
                <span>No Subscriptions</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle2 className="w-5 md:h-5 text-emerald-500" />
                <span>
                  {countryCode !== "IN" && countryCode !== "" ? "$1.00" : "₹45.00"} => single portrait{" "}
                  {countryCode !== "IN" && countryCode !== "" ? "$1.50" : "₹90.00"} => family portrait
                </span>
              </div>
            </div> */}

            <div className="mt-10 flex items-center gap-2 text-slate-500">
              <div className="flex items-center gap-2">
                {/* <CheckCircle2 className="w-5 h-5 text-emerald-500" /> */}
                <CheckCircle2 className="w-5 md:h-5 text-emerald-500" />
                {/* The greater than symbol below is not an error. But VSCode says so. Leave it as is*/}
                {/* <span>
                  {countryCode !== "IN" && countryCode !== "" ? "$1.00" : "₹45.00"} => single portrait{" "}
                  {countryCode !== "IN" && countryCode !== "" ? "$1.50" : "₹90.00"} => family portrait
                </span> */}

                <span
                  style={{
                    fontSize: "2rem",
                    fontWeight: "Bolder",
                    color: "#39f907"
                  }}
                >
                  {countryCode !== "IN" && countryCode !== ""
                    ? "$1.00"
                    : "₹45.00"}
                </span>

                <span>single portraits</span>
                <span
                  style={{
                    fontSize: "2rem",
                    fontWeight: "Bolder",
                    color: "#39f907"
                  }}
                >
                  {countryCode !== "IN" && countryCode !== ""
                    ? "$1.50"
                    : "₹90.00"}
                </span>

                <span>family portraits</span>
              </div>
            </div>

            <div className="flex items-center gap-1">
              {/* <CheckCircle2 className="w-5 h-5 text-emerald-500" /> */}
              <CheckCircle2 className="w-5 md:h-5 text-emerald-500" />
              <span>No Subscriptions => Pay per portrait only</span>
            </div>

            {/* Video walkthrough playback buttons */}
            <div className="mt-20 pt-4 border-t border-white/5">
              <p className="text-[10px] font-black text-indigo-400 uppercase tracking-[0.2em] mb-3">
                Instant Video Guides
              </p>
              <div
                className={
                  mobile ? "flex flex-wrap gap-1" : "flex flex-wrap gap-10"
                }
              >
                <a
                  href="https://youtu.be/-aNA_3ga3w8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-slate-900/60 hover:bg-indigo-600/25 hover:border-indigo-500/40 text-slate-200 hover:text-white px-5 py-3 rounded-xl font-bold text-sm flex items-center gap-2 transition-all border border-white/5 active:scale-[0.97]"
                  style={{ padding: "10px" }}
                >
                  <Play className="w-4 md:h-4 text-indigo-400 fill-indigo-400/15" />{" "}
                  Explainer
                </a>
                <a
                  href="https://youtu.be/IvwZG-hdxPA"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-slate-900/60 hover:bg-emerald-600/25 hover:border-emerald-500/40 text-slate-200 hover:text-white px-5 py-3 rounded-xl font-bold text-sm flex items-center gap-2 transition-all border border-white/5 active:scale-[0.97]"
                  style={{ padding: "10px" }}
                >
                  <Play className="w-4 md:h-4 text-emerald-400 fill-emerald-400/15" />{" "}
                  Quick Tour
                </a>
                <a
                  href="https://youtu.be/_1vInrqapzk"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-slate-900/60 hover:bg-rose-600/25 hover:border-rose-500/40 text-slate-200 hover:text-white px-5 py-3 rounded-xl font-bold text-sm flex items-center gap-2 transition-all border border-white/5 active:scale-[0.97]"
                  style={{ padding: "10px" }}
                >
                  <Play className="w-4 md:h-4 text-rose-400 fill-rose-400/15" />{" "}
                  Detailed Tour
                </a>
              </div>
            </div>
          </div>

          <div className="relative items-center grid grid-cols-6 grid-rows-10 gap-3 h-[700px] lg:h-[800px] animate-scale-in delay-200">
            {collageItems.map((item) => (
              <div
                key={item.id}
                // className={`${item.span} relative flex justify-center group rounded-2xl overflow-hidden border border-white/10 shadow-2xl`}
                className={`${item.span} relative items-center group rounded-2xl border border-white/10 shadow-2xl`}
              >
                <img
                  src={item.url}
                  alt={item.title}
                  onLoad={handleLoad}
                  // className="h-full object-cover transition-transform duration-700 group-hover:scale-115"
                  className="w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  referrerPolicy="no-referrer"
                />

                {/* Info Button */}
                <button
                  onClick={() =>
                    setSelectedImage({
                      url: item.url,
                      title: item.title,
                      prompt: item.prompt,
                      remarks: item.remarks,
                      references: item.references || [],
                      resolution: item.resolution
                    })
                  }
                  // className="absolute top-3 right-3 p-2 glass rounded-full border border-white/10 transition-all duration-300 hover:bg-white/20 z-10"
                  className="absolute p-2 glass rounded-full border border-white/10 transition-all duration-300 hover:bg-white/20 z-10"
                  style={{
                    width: "30px",
                    height: "30px",
                    marginLeft: mobile ? "3px" : "5px",
                    marginTop: mobile ? "3px" : "5px"
                  }}
                  title="View Image Generation details"
                >
                  {/* <Info className="w-4 h-4 text-white" /> */}
                  <Info className="text-white" />
                </button>

                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                {/* <div className="absolute bottom-3 left-3 right-3 p-2 glass rounded-lg border border-white/10 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300"> */}
                <div
                  className="absolute bottom-3 left-3 right-3 p-2 glass rounded-lg border border-white/10 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300"
                  style={{ height: "max-content", marginTop: "13%" }}
                >
                  <p className="text-[10px] font-mono text-indigo-300 uppercase tracking-wider mb-1">
                    Prompt
                  </p>
                  <p className="text-xs font-medium text-white leading-tight">
                    {item.prompt}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Image Preview Modal */}
      {selectedImage && (
        <div
          // className="fixed inset-0 z-[100] flex justify-center items-start p-4 sm:p-8 bg-slate-950/90 backdrop-blur-sm overflow-y-auto animate-fade-in"
          className="fixed inset-0 z-10 flex justify-center items-start p-4 sm:p-8 bg-slate-950/90 backdrop-blur-sm overflow-y-auto animate-fade-in"
          onClick={() => setSelectedImage(null)}
        >
          <div
            // className="relative max-w-5xl w-full glass rounded-3xl sm:rounded-[2rem] overflow-hidden border border-white/10 my-4 sm:my-8 animate-scale-in"
            className="relative max-w-5xl w-full glass rounded-3xl sm:rounded-[2rem] border border-white/10 my-4 sm:my-8 animate-scale-in"
            style={{
              marginTop: "100px",
              width: mobile ? "95%" : "85%",
              height: "85%",
              marginLeft: mobile ? "" : "100px"
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setSelectedImage(null)}
              // className="absolute top-6 right-6 p-2 glass rounded-full border border-white/10 hover:bg-white/20 transition-colors z-10"
              className="p-2 glass rounded-full border border-white/10 hover:bg-white/20 transition-colors z-10"
              style={{
                position: "absolute",
                width: "30px",
                height: "30px",
                marginTop: "8px",
                // marginLeft: "1380px",
                right: mobile ? "20px" : "24px",
                background: "red"
              }}
            >
              <X className="w-6 md:h-6 text-white" />
            </button>

            {/* <div className="grid lg:grid-cols-2"> */}
            <div
              className="grid lg:grid-cols-2 rounded-3xl"
              style={{ height: mobile ? "" : "100%", overflowY: "auto" }}
            >
              {/* <div className="relative bg-slate-900 flex items-center justify-center overflow-hidden"> */}
              <div className="relative bg-slate-900 flex items-center justify-center overflow-y-auto">
                <img
                  src={selectedImage.url}
                  alt={selectedImage.title}
                  onLoad={handleLoad}
                  // className="w-full h-auto max-h-[50vh] lg:max-h-none lg:h-full object-contain lg:object-cover"
                  className={
                    dimensions.width > dimensions.height
                      ? "w-full h-auto max-h-[50vh] lg:max-h-none lg:h-full object-cover lg:object-cover"
                      : "h-full w-auto max-h-[50vh] lg:max-h-none lg:h-full object-cover lg:object-cover"
                  }
                  style={{ overflowY: "auto", objectFit: "scale-down" }}
                  referrerPolicy="no-referrer"
                />
              </div>
              {/* <div className="p-8 md:p-12 flex flex-col bg-slate-900/50"> */}
              <div
                className="flex flex-col bg-slate-900/50"
                style={{ padding: "40px" }}
              >
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-xs font-medium mb-6">
                  <Sparkles className="w-3 md:h-3" />
                  {mobile ? (
                    <span>AI Studio Result</span>
                  ) : (
                    <span>AI Studio Result (on the Left)</span>
                  )}
                </div>
                <h3
                  className="text-3xl text-4xl text-white font-bold mb-6"
                  style={{ margin: "10px" }}
                >
                  {selectedImage.title}
                </h3>

                <div className="space-y-8">
                  {/* Reference Images Section */}
                  <div>
                    <p className="text-[10px] font-mono text-indigo-300 uppercase tracking-[0.2em] mb-4">
                      Reference Inputs
                    </p>
                    {/* <div className="grid grid-cols-2 sm:grid-cols-4 gap-4"> */}
                    <div className="grid grid-cols-3 gap-4 ">
                      {selectedImage.references.map((ref, idx) => (
                        <div key={idx} className="space-y-2">
                          <div className="rounded-xl overflow-y-auto flex justify-center border border-white/10 bg-slate-800">
                            <img
                              src={ref.url}
                              alt={`Ref ${idx + 1}`}
                              className="w-full h-full object-cover hover:grayscale-0 transition-all duration-500"
                              referrerPolicy="no-referrer"
                            />
                          </div>
                          <p className="text-[9px] font-medium text-slate-500 text-center uppercase tracking-wider">
                            {ref.prompt}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div>
                    <p className="text-[10px] font-mono text-indigo-300 uppercase tracking-[0.2em] mb-3">
                      Final Prompt Directive
                    </p>
                    <div className="p-6 rounded-2xl bg-slate-800/50 border border-slate-700 italic text-slate-200 leading-relaxed text-sm">
                      {selectedImage.prompt}
                    </div>
                    {selectedImage.remarks !== "" ? (
                      <React.Fragment>
                        <br></br>
                        <p className="text-[10px] font-mono text-indigo-300 uppercase tracking-[0.2em] mb-3">
                          Remarks
                        </p>
                        <div className="p-6 rounded-2xl bg-slate-800/50 border border-slate-700 italic text-slate-200 leading-relaxed text-sm">
                          {selectedImage.remarks}
                        </div>
                      </React.Fragment>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="flex flex-wrap items-center gap-4 text-xs text-slate-400">
                    <div className="flex items-center gap-2">
                      <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />
                      <span>Identity Locked</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />
                      {/* <span>2K Resolution</span> */}
                      <span>{selectedImage.resolution} Resolution</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Features Grid */}
      <section className="py-24 px-6 bg-slate-900/50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20">
            <h2 className="text-4xl lg:text-5xl text-white font-bold mb-6">
              Unmatched Creative Control
            </h2>
            <p className="text-xl text-slate-400 max-w-2xl mx-auto">
              Everything you need to create the perfect portrait, powered by
              state-of-the-art AI.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Individual Portraits */}
            <div className="p-8 rounded-3xl bg-slate-800/50 border border-slate-700 hover:border-indigo-500/50 transition-all group">
              <div className="w-14 h-14 bg-indigo-500/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                {/* <Camera className="w-8 h-8 text-indigo-400" /> */}
                <Camera className="w-8 md:h-8 text-indigo-400" />
              </div>
              <h3 className="text-2xl text-white font-bold mb-4">
                Individual Portraits
              </h3>
              <p className="text-slate-400 leading-relaxed mb-6">
                Turn any selfie into a professional headshot. Perfect for
                LinkedIn, resumes, or graduation announcements.
              </p>
              <ul className="space-y-3 text-sm text-slate-300">
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />{" "}
                  Business Attire
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />{" "}
                  Graduation Gowns
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />{" "}
                  Casual & Lifestyle
                </li>
              </ul>
            </div>

            {/* Group Portraits */}
            <div className="p-8 rounded-3xl bg-slate-800/50 border border-slate-700 hover:border-emerald-500/50 transition-all group">
              <div className="w-14 h-14 bg-emerald-500/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Users className="w-8 md:h-8 text-emerald-400" />
              </div>
              <h3 className="text-2xl text-white font-bold mb-4">
                Group Portraits
              </h3>
              <p className="text-slate-400 leading-relaxed mb-6">
                Perfect for corporate teams, sports clubs, or friend groups. Our
                AI ensures everyone looks their best in a synchronized
                composition.
              </p>
              <ul className="space-y-3 text-sm text-slate-300">
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" /> Team
                  Coordination
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />{" "}
                  Professional Alignment
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" /> Small
                  Group Support
                </li>
              </ul>
            </div>

            {/* Family Portraits */}
            <div className="p-8 rounded-3xl bg-slate-800/50 border border-slate-700 hover:border-pink-500/50 transition-all group">
              <div className="w-14 h-14 bg-pink-500/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Heart className="w-8 md:h-8 text-pink-400" />
              </div>
              <h3 className="text-2xl text-white font-bold mb-4">
                Family Portraits
              </h3>
              <p className="text-slate-400 leading-relaxed mb-6">
                Capture the warmth of family. From multi-generational portraits
                to cozy holiday shots, we bring your loved ones together.
              </p>
              <ul className="space-y-3 text-sm text-slate-300">
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />{" "}
                  Multi-generational
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />{" "}
                  Candid & Posed
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" /> Pets
                  Included!
                </li>
              </ul>
            </div>

            {/* Automotive */}
            <div className="p-8 rounded-3xl bg-slate-800/50 border border-slate-700 hover:border-orange-500/50 transition-all group">
              <div className="w-14 h-14 bg-orange-500/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Car className="w-8 md:h-8 text-orange-400" />
              </div>
              <h3 className="text-2xl text-white font-bold mb-4">
                Automotive & Marine
              </h3>
              <p className="text-slate-400 leading-relaxed mb-6">
                Place yourself or your group in luxury settings. From exotic
                cars and yachts to custom bikes and speedboats.
              </p>
              <ul className="space-y-3 text-sm text-slate-300">
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />{" "}
                  Exotic Cars & Bikes
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />{" "}
                  Yachts & Luxury Boats
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />{" "}
                  Action & Motion Shots
                </li>
              </ul>
            </div>

            {/* Global Locations */}
            <div className="p-8 rounded-3xl bg-slate-800/50 border border-slate-700 hover:border-cyan-500/50 transition-all group">
              <div className="w-14 h-14 bg-cyan-500/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Globe className="w-8 md:h-8 text-cyan-400" />
              </div>
              <h3 className="text-2xl text-white font-bold mb-4">
                Global Destinations
              </h3>
              <p className="text-slate-400 leading-relaxed mb-6">
                Travel the world without leaving your home. Teleport your
                portraits to iconic landmarks and breathtaking locations.
              </p>
              <ul className="space-y-3 text-sm text-slate-300">
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />{" "}
                  Iconic Landmarks
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" /> World
                  Wonders
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />{" "}
                  Seasonal Environments
                </li>
              </ul>
            </div>

            {/* High-End Fashion */}
            <div className="p-8 rounded-3xl bg-slate-800/50 border border-slate-700 hover:border-amber-500/50 transition-all group">
              <div className="w-14 h-14 bg-amber-500/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Shirt className="w-8 md:h-8 text-amber-400" />
              </div>
              <h3 className="text-2xl text-white font-bold mb-4">
                High-End Fashion
              </h3>
              <p className="text-slate-400 leading-relaxed mb-6">
                Explore a world of cultural elegance. From regal Sherwanis to
                gorgeous Kanchivaram silk sarees and designer couture.
              </p>
              <ul className="space-y-3 text-sm text-slate-300">
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />{" "}
                  Traditional Sherwanis
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />{" "}
                  Kanchivaram Silk Sarees
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />{" "}
                  Global Designer Wear
                </li>
              </ul>
            </div>

            {/* Exquisite Jewelry */}
            <div className="p-8 rounded-3xl bg-slate-800/50 border border-slate-700 hover:border-sky-500/50 transition-all group">
              <div className="w-14 h-14 bg-sky-500/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Gem className="w-8 md:h-8 text-sky-400" />
              </div>
              <h3 className="text-2xl text-white font-bold mb-4">
                Exquisite Jewelry
              </h3>
              <p className="text-slate-400 leading-relaxed mb-6">
                Adorn your portraits with brilliance. Choose from simple gold
                accents to exotic diamond necklaces, bangles, and head
                ornaments.
              </p>
              <ul className="space-y-3 text-sm text-slate-300">
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />{" "}
                  Diamond & Gold Sets
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />{" "}
                  Traditional Ornaments
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />{" "}
                  Custom Brilliance
                </li>
              </ul>
            </div>

            {/* Text-Only Directives */}
            <div className="p-8 rounded-3xl bg-slate-800/50 border border-slate-700 hover:border-rose-500/50 transition-all group">
              <div className="w-14 h-14 bg-rose-500/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Terminal className="w-8 md:h-8 text-rose-400" />
              </div>
              <h3 className="text-2xl text-white font-bold mb-4">
                Text-Only Directives
              </h3>
              <p className="text-slate-400 leading-relaxed mb-6">
                Command your vision with pure text. "Use Tuxedo for all members"
                or "Christmas clothing with a decorated tree and snow outside."
              </p>
              <ul className="space-y-3 text-sm text-slate-300">
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" /> Group
                  Theme Sync
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />{" "}
                  Complex Scene Building
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />{" "}
                  Seasonal Transformations
                </li>
              </ul>
            </div>

            {/* Photographic Precision */}
            <div className="p-8 rounded-3xl bg-slate-800/50 border border-slate-700 hover:border-lime-500/50 transition-all group">
              <div className="w-14 h-14 bg-lime-500/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Aperture className="w-8 md:h-8 text-lime-400" />
              </div>
              <h3 className="text-2xl text-white font-bold mb-4">
                Photographic Precision
              </h3>
              <p className="text-slate-400 leading-relaxed mb-6">
                Master the art of the shot. Fine-tune Bokeh effects, specify
                profile views, and maintain the original expressions of your
                subjects.
              </p>
              <ul className="space-y-3 text-sm text-slate-300">
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />{" "}
                  Custom Bokeh Effects
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />{" "}
                  Profile & Angle Views
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 md:h-4 text-emerald-500" />{" "}
                  Expression Preservation
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Replication Engine & Style Builder Section */}
      <section className="py-24 px-6 bg-slate-900">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-24">
            <div className="animate-slide-up">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-violet-500/10 border border-violet-500/20 text-violet-400 text-sm font-medium mb-6">
                {/* <Palette className="w-4 h-4" /> */}
                <Palette className="w-4 md:h-4" />
                <span>The Replication Engine</span>
              </div>
              <h2 className="text-4xl lg:text-6xl text-white font-bold mb-8 leading-tight">
                Beyond Style. <br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-violet-400 to-fuchsia-400">
                  Total Replication.
                </span>
              </h2>
              <p className="text-xl text-slate-400 mb-8 leading-relaxed">
                Upload reference images to replicate anything—from the exact
                weave of a Kanchivaram saree to the specific posture of a model.
                Our engine doesn't just "guess"; it reconstructs your vision
                with surgical precision.
              </p>

              <div className="grid sm:grid-cols-2 gap-6">
                <div className="p-6 rounded-2xl bg-slate-800/50 border border-slate-700">
                  {/* <Layers className="w-8 h-8 text-violet-400 mb-4" /> */}
                  <Layers className="w-8 md:h-8 text-violet-400 mb-4" />
                  <h4 className="font-bold text-white mb-2 text-lg">
                    Visual Cloning
                  </h4>
                  <p className="text-sm text-slate-400">
                    Upload a dress, a bike, or a piece of jewelry. Our AI clones
                    the details perfectly into your portrait.
                  </p>
                </div>
                <div className="p-6 rounded-2xl bg-slate-800/50 border border-slate-700">
                  {/* <MousePointer2 className="w-8 h-8 text-fuchsia-400 mb-4" /> */}
                  <MousePointer2 className="w-8 md:h-8 text-fuchsia-400 mb-4" />
                  <h4 className="font-bold mb-2 text-white text-lg">
                    Selective Directives
                  </h4>
                  <p className="text-sm text-slate-400">
                    "Replicate only the shoes but not the posture." You decide
                    exactly what to keep and what to change.
                  </p>
                </div>
              </div>
            </div>

            <div className="relative animate-scale-in">
              <div className="aspect-square rounded-[40px] overflow-hidden border border-white/10 shadow-2xl relative">
                <img
                  // src="https://picsum.photos/seed/replication/800/800"
                  src="/images/webp/branch.webp"
                  width="800"
                  height="800"
                  alt="AI Replication Engine"
                  className="w-full h-full object-cover"
                  referrerPolicy="no-referrer"
                />
                <div className="absolute inset-0 bg-gradient-to-br from-violet-600/20 to-transparent" />

                {/* Floating UI Elements */}
                {/* <div className="absolute top-8 right-8 glass p-4 rounded-2xl border border-white/20 shadow-xl max-w-[200px] animate-bounce-slow"> */}
                <div
                  className="absolute top-8 right-8 glass p-4 rounded-2xl border border-white/20 shadow-xl max-w-[200px] animate-bounce-slow"
                  style={{
                    height: "max-content",
                    marginTop: mobile ? "250px" : "475px",
                    marginLeft: mobile ? "50px" : "20px"
                  }}
                >
                  <div className="flex items-center gap-2 mb-2">
                    <Tag className="w-4 md:h-4 text-violet-400" />
                    {/* <span className="text-[10px] font-bold uppercase tracking-widest"> */}
                    <span
                      className="text-[10px] font-bold uppercase tracking-widest"
                      style={{ margin: "5px" }}
                    >
                      Member Label
                    </span>
                  </div>
                  <p className="text-xs font-medium" style={{ margin: "5px" }}>
                    "Assign Member 1 to lean on the car in a relaxed pose."
                  </p>
                </div>

                {/* <div className="absolute bottom-8 left-8 glass p-4 rounded-2xl border border-white/20 shadow-xl max-w-[240px]"> */}
                <div
                  className="absolute bottom-8 left-8 glass p-4 rounded-2xl border border-white/20 shadow-xl max-w-[240px]"
                  style={{
                    height: "max-content",
                    marginTop: "20px",
                    marginLeft: mobile ? "95px" : "315px"
                  }}
                >
                  <div className="flex items-center gap-2 mb-2">
                    <Settings className="w-4 md:h-4 text-fuchsia-400" />
                    <span
                      className="text-[10px] font-bold uppercase tracking-widest"
                      style={{ margin: "5px" }}
                    >
                      Global Directive
                    </span>
                  </div>
                  <p className="text-xs font-medium" style={{ margin: "5px" }}>
                    "Cinematic lighting, shot on 85mm lens in a high-end London
                    studio."
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Deep Feature Breakdown */}
          <div className="grid md:grid-cols-3 gap-8">
            <div className="group">
              <h4 className="text-xl text-white font-bold mb-4 flex items-center gap-3">
                {/* <span className="w-8 h-8 rounded-lg bg-emerald-500/10 flex items-center justify-center text-emerald-400 text-sm"> */}
                <span
                  className="rounded-lg bg-emerald-500/10 flex items-center justify-center text-emerald-400 text-sm"
                  style={{ height: "30px", width: "30px" }}
                >
                  01
                </span>
                Interaction Directives
              </h4>
              <p className="text-slate-400 text-sm leading-relaxed">
                Don't just add accessories—interact with them. Tell the AI to
                have a member "sitting on the bike in a riding position" or
                "leaning against the yacht rail."
              </p>
            </div>
            <div className="group">
              <h4 className="text-xl text-white font-bold mb-4 flex items-center gap-3">
                {/* <span className="w-8 h-8 rounded-lg bg-indigo-500/10 flex items-center justify-center text-indigo-400 text-sm"> */}
                <span
                  className="rounded-lg bg-indigo-500/10 flex items-center justify-center text-indigo-400 text-sm"
                  style={{ height: "30px", width: "30px" }}
                >
                  02
                </span>
                Member-Specific Styling
              </h4>
              <p className="text-slate-400 text-sm leading-relaxed">
                Use group labels to micro-manage. Assign a specific Sherwani to
                Member 1 and a silk saree to Member 2, ensuring every individual
                is perfectly styled.
              </p>
            </div>
            <div className="group">
              <h4 className="text-xl text-white font-bold mb-4 flex items-center gap-3">
                {/* <span className="w-8 h-8 rounded-lg bg-violet-500/10 flex items-center justify-center text-violet-400 text-sm"> */}
                <span
                  className="rounded-lg bg-violet-500/10 flex items-center justify-center text-violet-400 text-sm"
                  style={{ height: "30px", width: "30px" }}
                >
                  03
                </span>
                Atmospheric Control
              </h4>
              <p className="text-slate-400 text-sm leading-relaxed">
                Global directives define the soul of the shot. Specify "dramatic
                cinematic lighting," "high-end camera optics," or "luxury studio
                environment" for the entire scene.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Prompt Directives Section */}
      <section className="py-24 px-6">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
          <div className="order-2 lg:order-1">
            <div className="relative rounded-3xl overflow-hidden border border-white/10 shadow-2xl">
              <img
                // src="https://picsum.photos/seed/ai-prompt/800/600"
                src="/images/webp/mushroom.webp"
                width="800"
                height="600"
                alt="Prompt Directives"
                className="w-full h-full object-cover"
                referrerPolicy="no-referrer"
              />
              <div className="absolute inset-0 bg-indigo-900/20" />
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full px-8">
                <div className="glass p-6 rounded-2xl border border-white/20 shadow-2xl">
                  <div className="flex items-center gap-3 mb-4">
                    <MessageSquare className="w-5 md:h-5 text-indigo-400" />
                    <span className="text-xs font-bold uppercase tracking-widest text-indigo-300">
                      Prompt Directive
                    </span>
                  </div>
                  <p className="text-lg font-medium italic text-white mb-2">
                    "Add a subtle gold necklace, change the background to a
                    modern office with soft bokeh, and give her a confident
                    smile."
                  </p>
                  <div className="h-1 w-full bg-indigo-500/30 rounded-full overflow-hidden">
                    <div className="h-full bg-indigo-400 w-full" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="order-1 lg:order-2">
            <h2 className="text-4xl lg:text-5xl text-white font-bold mb-8 leading-tight">
              Speak Your Vision Into Existence.
            </h2>
            <p className="text-xl text-slate-400 mb-8 leading-relaxed">
              Our advanced AI understands context. Use custom prompt directives
              to add accessories, adjust lighting, or even specify the mood of
              your group members.
            </p>
            <div className="space-y-6">
              <div className="flex gap-4">
                {/* <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-indigo-500/10 flex items-center justify-center"> */}
                <div
                  className="flex-shrink-0 rounded-xl bg-indigo-500/10 flex items-center justify-center"
                  style={{ height: "50px", width: "50px" }}
                >
                  <Sparkles className="w-6 md:h-6 text-indigo-400" />
                </div>
                <div>
                  <h4 className="text-lg text-white font-bold mb-1">
                    Fine-Grained Control
                  </h4>
                  <p className="text-slate-400 text-sm">
                    Add specific jewelry, glasses, or props with simple text
                    commands.
                  </p>
                </div>
              </div>
              <div className="flex gap-4">
                {/* <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-emerald-500/10 flex items-center justify-center"> */}
                <div
                  className="flex-shrink-0 w-12 h-12 rounded-xl bg-emerald-500/10 flex items-center justify-center"
                  style={{ height: "50px", width: "50px" }}
                >
                  <Users className="w-6 md:h-6 text-emerald-400" />
                </div>
                <div>
                  <h4 className="text-lg text-white font-bold mb-1">
                    Group Coordination
                  </h4>
                  <p className="text-slate-400 text-sm">
                    Direct each member's expression or attire individually for a
                    cohesive look.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* The aiComposz Advantage Section */}
      <section className="py-24 px-6 bg-[#0f172a] relative overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full -z-10 opacity-10">
          <div className="absolute top-0 left-0 w-[50%] h-[50%] bg-indigo-500 blur-[150px] rounded-full" />
        </div>

        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20">
            <h2 className="text-4xl lg:text-6xl text-white font-bold mb-6">
              The aiComposz Advantage
            </h2>
            <p className="text-xl text-slate-400 max-w-3xl mx-auto">
              Why settle for "close enough" when you can have perfection?
              Discover how we outperform general-purpose AI tools.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="p-8 rounded-[32px] bg-slate-800/30 border border-white/5 hover:bg-slate-800/50 transition-all">
              <div className="w-12 h-12 bg-indigo-500/10 rounded-xl flex items-center justify-center mb-6">
                <Fingerprint className="w-6 md:h-6 text-indigo-400" />
              </div>
              <h4 className="text-xl text-white font-bold mb-4">
                Identity Lock
              </h4>
              <p className="text-slate-400 text-sm leading-relaxed">
                General AI creates look-alikes. aiComposz uses proprietary
                biometric locks to ensure the subject in the generated image is
                unmistakably YOU.
              </p>
            </div>

            <div className="p-8 rounded-[32px] bg-slate-800/30 border border-white/5 hover:bg-slate-800/50 transition-all">
              <div className="w-12 h-12 bg-emerald-500/10 rounded-xl flex items-center justify-center mb-6">
                <UserCheck className="w-6 md:h-6 text-emerald-400" />
              </div>
              <h4 className="text-xl text-white font-bold mb-4">
                Expression Guard
              </h4>
              <p className="text-slate-400 text-sm leading-relaxed">
                We don't just swap faces. We preserve your original expressions,
                ensuring the soul and personality of your portrait remain
                intact.
              </p>
            </div>

            <div className="p-8 rounded-[32px] bg-slate-800/30 border border-white/5 hover:bg-slate-800/50 transition-all">
              <div className="w-12 h-12 bg-amber-500/10 rounded-xl flex items-center justify-center mb-6">
                <Cpu className="w-6 md:h-6 text-amber-400" />
              </div>
              <h4 className="text-xl text-white font-bold mb-4">
                Specialized vs. General
              </h4>
              <p className="text-slate-400 text-sm leading-relaxed">
                Free tools like Gemini Pro 3 are great for general art, but they
                lack the specialized "Portrait Studio" architecture required for
                professional consistency.
              </p>
            </div>

            <div className="p-8 rounded-[32px] bg-slate-800/30 border border-white/5 hover:bg-slate-800/50 transition-all">
              <div className="w-12 h-12 bg-rose-500/10 rounded-xl flex items-center justify-center mb-6">
                <Zap className="w-6 md:h-6 text-rose-400" />
              </div>
              <h4 className="text-xl text-white font-bold mb-4">
                Automated Mastery
              </h4>
              <p className="text-slate-400 text-sm leading-relaxed">
                What takes hours of manual prompting in other tools, aiComposz
                does automatically. We handle the hard work of identity
                preservation so you don't have to.
              </p>
            </div>
          </div>

          <div className="mt-16 p-8 rounded-[40px] bg-gradient-to-r from-indigo-900/40 to-slate-900/40 border border-white/10 text-center">
            <p className="text-lg text-indigo-200 font-medium">
              "While free tools generate images, aiComposz crafts identities.
              It's the difference between a generic sketch and a high-end studio
              portrait."
            </p>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-24 px-6 bg-indigo-600">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl lg:text-6xl font-bold mb-8 text-white">
            No Subscriptions. <br />
            Just Masterpieces.
          </h2>
          <p className="text-xl text-indigo-100 mb-12 max-w-2xl mx-auto">
            We believe professional art should be accessible. No monthly fees,
            no commitments. Just pay for what you create.
          </p>
          <div className="bg-white text-slate-900 rounded-[40px] p-12 shadow-2xl relative overflow-hidden">
            <div className="top-0 right-0 p-8">
              <ShieldCheck className="w-16 h-16 text-emerald-500 opacity-10" />
            </div>
            {/* <p className="text-indigo-600 font-bold uppercase tracking-widest mb-4">
              Starting At Only
            </p> */}
            <div className="flex items-center justify-center gap-2 mb-6">
              <span className="text-6xl lg:text-8xl font-black tracking-tighter">
                {countryCode !== "IN" && countryCode !== ""
                  ? "$1.00"
                  : "₹45.00"}
              </span>
              <span className="text-xl text-slate-500 font-medium">
                / single portrait
              </span>
            </div>
            <div className="flex items-center justify-center gap-2 mb-6">
              <span className="text-6xl lg:text-8xl font-black tracking-tighter">
                {countryCode !== "IN" && countryCode !== ""
                  ? "$1.50"
                  : "₹90.00"}
              </span>
              <span className="text-xl text-slate-500 font-medium">
                / family portrait <br></br>(upto 5 subjects)
              </span>
            </div>
            <p className="text-slate-500 mb-10 max-w-md mx-auto">
              High-resolution, studio-quality portraits delivered in seconds.
              Perfect for individuals and families alike.
            </p>

            {/* <button
              onClick={() => {
                if (user_id != -1) {
                  if (imgCredits > -1) {
                    window.location.href = `/enhance?imgCredits=${imgCredits}`;
                  } else {
                    alert(
                      "Please purchase 'Image Credits' before continuing..."
                    );
                    setBuyFlg(false);
                  }
                } else {
                  window.location.href = "/users/sign_in";
                }
              }}
              className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-6 rounded-3xl font-bold text-2xl transition-all shadow-xl shadow-indigo-200"
              style={{
                backgroundColor:
                  user_id != -1 ? (imgCredits > -1 ? "" : "grey") : ""
              }}
              title={imgCredits > 0 ? "" : "Buy Image Credits first!"}
            >
              Start Your Masterpiece
            </button> */}

            {user_id === -1 ? (
              <React.Fragment>
                <div className="flex flex-wrap justify-center gap-2">
                  <button
                    onClick={() => {
                      if (user_id != -1) {
                        if (imgCredits > -1) {
                          window.location.href = `/enhance?imgCredits=${imgCredits}`;
                        } else {
                          alert(
                            "Please purchase 'Image Credits' before continuing..."
                          );
                          setBuyFlg(false);
                        }
                      } else {
                        window.location.href = "/users/sign_in";
                      }
                    }}
                    className="bg-indigo-600 hover:bg-indigo-700 text-white py-6 px-6 rounded-3xl font-bold text-2xl transition-all shadow-l shadow-indigo-200"
                    style={{
                      backgroundColor:
                        user_id != -1 ? (imgCredits > -1 ? "" : "grey") : ""
                    }}
                    title={imgCredits > 0 ? "" : "Buy Image Credits first!"}
                  >
                    Register/Login
                  </button>

                  <button
                    onClick={() => {
                      window.location.href = "/users/auth/google_oauth2";
                    }}
                  >
                    <img
                      src={googleSignIn}
                      alt="SignIn"
                      height="70"
                      style={{
                        filter: "drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.5))"
                      }}
                    ></img>
                  </button>
                </div>
              </React.Fragment>
            ) : (
              <button
                onClick={() => {
                  if (user_id != -1) {
                    if (imgCredits > -1) {
                      window.location.href = `/enhance?imgCredits=${imgCredits}`;
                    } else {
                      alert(
                        "Please purchase 'Image Credits' before continuing..."
                      );
                      setBuyFlg(false);
                    }
                  } else {
                    window.location.href = "/users/sign_in";
                  }
                }}
                className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-6 px-6 rounded-3xl font-bold text-2xl transition-all shadow-xl shadow-indigo-200"
                style={{
                  backgroundColor:
                    user_id != -1 ? (imgCredits > -1 ? "" : "grey") : ""
                }}
                title={imgCredits > 0 ? "" : "Buy Image Credits first!"}
              >
                Start your Masterpiece
              </button>
            )}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-12 px-6 border-t border-white/5">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
          <div className="flex items-center gap-2">
            <div className="w-8 md:h-8 bg-indigo-600 rounded-lg flex items-center justify-center">
              <Sparkles className="text-white w-5 md:h-5" />
            </div>
            <span className="text-xl font-bold tracking-tighter">
              aiComposz
            </span>
          </div>
          <p className="text-slate-500 text-sm">
            © 2026 aiComposz Studio. Powered by Gemini 3 Pro.
          </p>
          <div className="flex gap-6">
            <button
              onClick={() => setIsShippingModalOpen(true)}
              className="text-slate-400 hover:text-white transition-colors"
            >
              Shipping Policy
            </button>
            <button
              onClick={() => setIsRefundModalOpen(true)}
              className="text-slate-400 hover:text-white transition-colors"
            >
              Refund Policy
            </button>
            <button
              onClick={() => setIsTermsModalOpen(true)}
              className="text-slate-400 hover:text-white transition-colors"
            >
              Terms
            </button>
            <button
              onClick={() => setIsPrivacyModalOpen(true)}
              className="text-slate-400 hover:text-white transition-colors"
            >
              Privacy
            </button>
            <button
              onClick={() => setIsContactModalOpen(true)}
              className="text-slate-400 hover:text-white transition-colors"
            >
              Contact
            </button>
          </div>
        </div>
      </footer>
      <TermsModal
        isOpen={isTermsModalOpen}
        onClose={() => setIsTermsModalOpen(false)}
        mobile={mobile}
        countryCode={countryCode}
      />
      <ShippingPolicyModal
        isOpen={isShippingModalOpen}
        onClose={() => setIsShippingModalOpen(false)}
        mobile={mobile}
        countryCode={countryCode}
      />

      <RefundPolicyModal
        isOpen={isRefundModalOpen}
        onClose={() => setIsRefundModalOpen(false)}
        mobile={mobile}
        countryCode={countryCode}
      />
      <PrivacyPolicyModal
        isOpen={isPrivacyModalOpen}
        onClose={() => setIsPrivacyModalOpen(false)}
        mobile={mobile}
        countryCode={countryCode}
      />
      <ContactModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
        mobile={mobile}
        countryCode={countryCode}
      />
    </div>
  );
};

export default LandingPage;
